const contentSections = document.querySelectorAll(".content-section");
const nextClaimButtons = document.querySelectorAll("[data-next-claim]");
const backArticleButtons = document.querySelectorAll("[data-back-article]");
const formContainer = document.getElementById("form");
let countdownInitialized = false;

//Assign and Map Klaviyo Elements as Variables, called once the embed loads
function setupKlaviyoListeners() {
  const klaviyoForm = formContainer.querySelector('form');
  const emailInput = klaviyoForm.querySelector('input[type="email"]');
  const klaviyoButton = klaviyoForm.querySelector('button[type="button"]');

  emailInput.required = true;

  klaviyoButton.addEventListener('click', () => {
    if (emailInput.checkValidity()) {
      // Assume the form data is valid since the button is enabled
      moveToNextSection(contentSections[1], contentSections[2]);

      if (!countdownInitialized) {
        const deadline = new Date(
          Date.parse(new Date()) + 1 * 1 * 15 * 60 * 1000
        );
        initializeClock("clockdiv", deadline);
        countdownInitialized = true;
      }
    }
  });
}

//Animated Transforms to Next "Page"
function moveToNextSection(currentSection, nextSection) {
  currentSection.style.transform = "translateX(-100%)";
  currentSection.style.opacity = "0";
  setTimeout(() => {
    currentSection.classList.add("hidden");
    nextSection.classList.remove("hidden");
    nextSection.style.transform = "translateX(100%)";
    setTimeout(() => {
      nextSection.style.transform = "translateX(0)";
      nextSection.style.opacity = "1";

      if (nextSection.id === "gift") {
        nextSection.style.backgroundColor = "#c8d1dc";
      }

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
  }, 250);
}

function moveToPreviousSection(currentSection, previousSection) {
  currentSection.style.transform = "translateX(100%)";
  currentSection.style.opacity = "0";
  setTimeout(() => {
    currentSection.classList.add("hidden");
    previousSection.classList.remove("hidden");
    previousSection.style.transform = "translateX(-100%)";
    setTimeout(() => {
      previousSection.style.transform = "translateX(0)";
      previousSection.style.opacity = "1";
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
  }, 250);
}


//Button Array Function Mapping
nextClaimButtons.forEach((button) => {
  button.addEventListener("click", () => {
    moveToNextSection(contentSections[0], contentSections[1]);
  });
});

backArticleButtons.forEach((button) => {
  button.addEventListener("click", () => {
    moveToPreviousSection(contentSections[1], contentSections[0]);
  });
});

//Klaviyo Embed Monitor
const formCheckInterval = setInterval(() => {
  const klaviyoForm = formContainer.querySelector("form");
  if (klaviyoForm) {
    setupKlaviyoListeners();
    clearInterval(formCheckInterval);
  }
}, 500);
